import React, { createContext, useState, useEffect, useContext } from 'react';

const SimulationLocalStorageContext = createContext(null);

export const SimulationLocalStorageProvider = ({ children }) => {
    const [simulationLocalStorageValue, setSimulationLocalStorageValue] = useState(JSON.parse(localStorage.getItem('Premmiar@simulation')));

    useEffect(() => {
        window.localStorage.setItem('Premmiar@simulation', JSON.stringify(simulationLocalStorageValue));
    }, [simulationLocalStorageValue]);

    return (
        <SimulationLocalStorageContext.Provider value={{ simulationLocalStorageValue, setSimulationLocalStorageValue }}>
            {children}
        </SimulationLocalStorageContext.Provider>
    );
};

export const useSimulationLocalStorageContext = () => useContext(SimulationLocalStorageContext);